export const getUser = () => {
  const userStorage: string | null = localStorage.getItem('cd_usua')
  const user: { cd_usua: string } = userStorage && JSON.parse(userStorage)
  return user ? user.cd_usua : ''
}

export const getUserEmail = () => {
  const userStorage: string | null = localStorage.getItem('ds_emai')
  const userEmail: { ds_emai: string } = userStorage && JSON.parse(userStorage)
  return userEmail ? userEmail.ds_emai : ''
}
